import React from "react";

import withStyles from "@mui/styles/withStyles";
import { colors } from "@zapalacorp/tokens";
import classnames from "classnames";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      padding: "2px 8px",
      borderRadius: "100px",
      whiteSpace: "nowrap",
      width: "fit-content",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Manrope",
      fontSize: "11px",
      fontWeight: 700,
      lineHeight: "16px",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

const BadgeShipmentTrackingStatusComponent = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case "booked":
      return renderBadge(colors.gray25, colors.gray200, value);
    case "collected from shipper":
      return renderBadge("#E0EAFF", "#444CE7", value);
    case "not arrived at port of load":
      return renderBadge("#FEE4E2", "#D92D20", value);
    case "waiting at port of load":
      return renderBadge("#FEF0C7", "#DC6803", value);
    case "shipped on board":
      return renderBadge("#FCE7F6", "#DD2590", value);
    case "underway":
      return renderBadge(colors.warning50, colors.warning700, value);
    case "underway to a transhipment port":
      return renderBadge("#F4EBFF", "#42307D", value);
    case "arrival at transhipment port":
      return renderBadge("#EAECF5", "#308CDB", value);
    case "waiting at transhipment port":
      return renderBadge("#FEF0C7", "#DC6803", value);
    case "shipped on board at transhipment port":
      return renderBadge("#FCE7F6", "#851651", value);
    case "arrived at port or discharge":
      return renderBadge("#EAECF5", "#308CDB", value);
    case "waiting at destination port":
      return renderBadge("#FEF0C7", "#DC6803", value);
    case "left the destination port":
      return renderBadge("#E0F2FE", "#0B4A6F", value);
    case "shipment completed":
      return renderBadge(colors.success50, colors.success700, "Completed");
    case "waiting for update":
      return renderBadge("#E4E7EC", "#475467", value);
    case "tracking not available":
      return renderBadge(colors.error50, colors.error700, value);
    default:
      return renderBadge("#eafaf9", "#38CFC4", value);
  }
};

export default BadgeShipmentTrackingStatusComponent;
